<template>
  <div class="kontak-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="kontak-card animated animate__bounceIn elevation-0">
          <div class="kontak-toolbar">
            <div class="kontak-toolbar__left">
              <div class="kontak-toolbar__icon">
                <v-icon>mdi-account-box-outline</v-icon>
              </div>
              <div>
                <div class="kontak-toolbar__title">Master Kontak</div>
                <div class="kontak-toolbar__sub">
                  {{ records.length || 0 }} kontak tersimpan
                </div>
              </div>
            </div>

            <div class="kontak-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari nama / nomor..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="kontak-search"
                clearable
              ></v-text-field>

              <v-tooltip bottom color="#0d4a36">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="kontak-icon-btn"
                    v-on="on"
                    v-show="page.actions.refresh"
                    @click="fetchRecords"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Muat ulang</span>
              </v-tooltip>

              <v-btn
                class="kontak-btn-primary"
                v-show="page.actions.add"
                @click="openForm"
              >
                <v-icon left small>mdi-plus</v-icon>
                Tambah Kontak
              </v-btn>
            </div>
          </div>

          <!-- Desktop table -->
          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="records"
            :items-per-page="table.options.itemsPerPage"
            :page.sync="table.options.page"
            class="kontak-table"
            :loading="loading.table"
            loading-text="Memuat kontak..."
            :search="search"
            hide-default-footer
            @page-count="table.options.pageCount = $event"
          >
            <v-progress-linear
              slot="progress"
              color="#1f7a57"
              height="2"
              indeterminate
            ></v-progress-linear>

            <template v-slot:item.name="{ item }">
              <div class="kontak-name-cell">
                <div class="kontak-name-cell__mark">
                  {{ (item.name || 'K').charAt(0).toUpperCase() }}
                </div>
                <div>
                  <div class="kontak-name-cell__title">{{ item.name }}</div>
                  <div class="kontak-name-cell__hint">Kontak penerima</div>
                </div>
              </div>
            </template>

            <template v-slot:item.phone="{ value }">
              <span class="kontak-phone">{{ value || '—' }}</span>
            </template>

            <template v-slot:item.status="{ value }">
              <span
                class="kontak-status"
                :class="isActive(value) ? 'is-online' : 'is-idle'"
              >
                <span class="kontak-status__dot"></span>
                {{ isActive(value) ? 'Aktif' : 'Nonaktif' }}
              </span>
            </template>

            <template v-slot:item.id="{ value }">
              <div class="kontak-row-actions">
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="kontak-action-edit"
                      v-on="on"
                      v-show="page.actions.edit"
                      @click="editRecord(value)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Ubah</span>
                </v-tooltip>
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="kontak-action-delete"
                      v-on="on"
                      v-show="page.actions.delete"
                      @click="postDeleteRecord(value)"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Hapus</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="kontak-empty">
                <v-icon large color="#8fd6b5">mdi-account-box-outline</v-icon>
                <div class="kontak-empty__title">Belum ada kontak</div>
                <div class="kontak-empty__sub">
                  Tambahkan kontak penerima untuk memudahkan pengiriman pesan
                </div>
                <v-btn
                  class="kontak-btn-primary mt-4"
                  small
                  v-show="page.actions.add"
                  @click="openForm"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Tambah Kontak
                </v-btn>
              </div>
            </template>
          </v-data-table>

          <!-- Mobile cards -->
          <div class="kontak-mobile" v-show="device.mobile">
            <div
              v-for="item in filterItems"
              :key="item.id"
              class="kontak-mobile-card"
            >
              <div class="kontak-mobile-card__top">
                <div class="kontak-name-cell">
                  <div class="kontak-name-cell__mark">
                    {{ (item.name || 'K').charAt(0).toUpperCase() }}
                  </div>
                  <div>
                    <div class="kontak-name-cell__title">{{ item.name }}</div>
                    <div class="kontak-phone mt-1">{{ item.phone }}</div>
                  </div>
                </div>
                <v-menu bottom left origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" class="kontak-menu-btn">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="kontak-menu">
                    <v-list-item
                      @click="editRecord(item.id || item.uuid)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#1f7a57">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ubah Data</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id || item.uuid)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#c62828">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Hapus Data</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="kontak-mobile-card__meta">
                <span
                  class="kontak-status"
                  :class="isActive(item.status) ? 'is-online' : 'is-idle'"
                >
                  <span class="kontak-status__dot"></span>
                  {{ isActive(item.status) ? 'Aktif' : 'Nonaktif' }}
                </span>
              </div>
            </div>

            <div v-if="!filterItems.length" class="kontak-empty pa-8">
              <v-icon large color="#8fd6b5">mdi-account-box-outline</v-icon>
              <div class="kontak-empty__title">Belum ada kontak</div>
              <div class="kontak-empty__sub">
                Tambahkan kontak penerima untuk memudahkan pengiriman pesan
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? '520px' : '100%'"
      persistent
      :fullscreen="device.mobile"
      content-class="kontak-dialog"
    >
      <v-card class="kontak-dialog-card">
        <div class="kontak-dialog-header">
          <div class="kontak-dialog-header__copy">
            <v-icon class="mr-2">mdi-account-plus-outline</v-icon>
            {{ form.edit ? 'Ubah Kontak' : 'Tambah Kontak' }}
          </div>
          <v-btn icon dark small @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="kontak-dialog-body">
          <div class="kontak-field-label">Nama</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Nama kontak"
            v-model="record.name"
            dense
            class="kontak-field mb-4"
            prepend-inner-icon="mdi-account-outline"
          ></v-text-field>

          <div class="kontak-field-label">Nomor Telepon</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="62812xxxxxxxx"
            v-model="record.phone"
            dense
            class="kontak-field mb-4"
            prepend-inner-icon="mdi-phone"
          ></v-text-field>

          <div class="kontak-switch-box">
            <div>
              <div class="kontak-switch-box__title">Status Aktif</div>
              <div class="kontak-switch-box__sub">
                Kontak nonaktif tidak ditampilkan saat kirim pesan
              </div>
            </div>
            <v-switch
              v-model="record.status"
              color="#1f7a57"
              hide-details
              dense
              class="mt-0 pt-0"
            ></v-switch>
          </div>
        </v-card-text>

        <v-divider class="kontak-divider"></v-divider>
        <v-card-actions class="kontak-dialog-actions">
          <v-btn text class="kontak-btn-ghost" @click="closeForm">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="kontak-btn-primary"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah
          </v-btn>
          <v-btn
            class="kontak-btn-primary"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "animate.css";

export default {
  name: "master-data-contact",
  data: () => ({
    headers: [
      {
        text: "Nama",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Nomor", value: "phone", sortable: true },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "status",
        width: 140,
      },
      {
        text: "Aksi",
        value: "id",
        width: 110,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
    ]),
    filterItems() {
      if (!this.search) return this.records || [];
      const q = this.search.toLowerCase();
      return (this.records || []).filter((item) => {
        const name = (item.name || "").toLowerCase();
        const phone = (item.phone || "").toLowerCase();
        return name.indexOf(q) > -1 || phone.indexOf(q) > -1;
      });
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/master-data/contact",
      pagination: false,
      title: "MASTER KONTAK",
      subtitle: "Berikut Daftar Seluruh Kontak Yang Tersedia",
      showtable: true,
      breadcrumbs: [
        {
          text: "Data Master",
          disabled: true,
          href: "",
        },
        {
          text: "Kontak",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: true,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "assignFileBrowse",
      "setLoading",
      "setRecord",
      "setForm",
    ]),
    isActive(value) {
      if (typeof value === "object" && value !== null) {
        return !!(value.text && String(value.text).toLowerCase().includes("aktif"));
      }
      return value === true || value === 1 || value === "1" || value === "true";
    },
    openForm: function () {
      this.setForm({
        add: true,
        edit: false,
      });
      this.setRecord({ status: true });
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postAddNewRecord: function () {
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord: function (val) {
      this.postEdit(val);
      this.setForm({
        add: true,
        edit: true,
      });
    },
    postUpdateRecord: function () {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },
    postDownload(val) {
      window.open(val, "__blank");
    },
  },
};
</script>

<style scoped>
.kontak-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.kontak-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.kontak-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.kontak-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.kontak-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.kontak-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.kontak-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.2;
}

.kontak-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.kontak-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.kontak-search {
  max-width: 280px;
  min-width: 180px;
}

.kontak-search >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
  min-height: 38px !important;
}

.kontak-search >>> fieldset {
  border-color: rgba(143, 214, 181, 0.35) !important;
}

.kontak-search >>> input,
.kontak-search >>> .v-icon {
  color: #f4fbf7 !important;
}

.kontak-search >>> input::placeholder {
  color: rgba(244, 251, 247, 0.55) !important;
}

.kontak-icon-btn {
  color: #f4fbf7 !important;
}

.kontak-icon-btn:hover {
  background: rgba(143, 214, 181, 0.18) !important;
}

.kontak-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.kontak-btn-primary:hover {
  background: linear-gradient(145deg, #c8f0da, #9fdebf) !important;
}

.kontak-table {
  background: transparent !important;
}

.kontak-table >>> thead th {
  background: var(--gw-fog) !important;
  color: var(--gw-forest) !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--gw-line) !important;
}

.kontak-table >>> tbody td {
  border-bottom: 1px solid var(--gw-line) !important;
  color: var(--gw-ink);
  height: 68px !important;
}

.kontak-table >>> tbody tr:hover {
  background: rgba(143, 214, 181, 0.08) !important;
}

.kontak-name-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.kontak-name-cell__mark {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  color: #0b3d2e;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.kontak-name-cell__title {
  font-weight: 600;
  color: var(--gw-ink);
  line-height: 1.2;
}

.kontak-name-cell__hint {
  margin-top: 0.15rem;
  font-size: 0.72rem;
  color: var(--gw-muted);
}

.kontak-phone {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
  color: var(--gw-forest);
  letter-spacing: 0.02em;
}

.kontak-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid var(--gw-line);
  background: #fff;
  color: var(--gw-muted);
}

.kontak-status.is-online {
  border-color: rgba(31, 122, 87, 0.25);
  background: rgba(143, 214, 181, 0.2);
  color: var(--gw-forest);
}

.kontak-status.is-idle {
  border-color: var(--gw-line);
  background: var(--gw-fog);
  color: var(--gw-muted);
}

.kontak-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #91a59b;
}

.kontak-status.is-online .kontak-status__dot {
  background: var(--gw-leaf);
  box-shadow: 0 0 0 3px rgba(31, 122, 87, 0.15);
}

.kontak-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}

.kontak-action-edit {
  color: var(--gw-leaf) !important;
}

.kontak-action-delete {
  color: #c62828 !important;
}

.kontak-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  text-align: center;
}

.kontak-empty__title {
  margin-top: 0.75rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--gw-ink);
}

.kontak-empty__sub {
  margin-top: 0.25rem;
  font-size: 0.88rem;
  color: var(--gw-muted);
  max-width: 320px;
}

.kontak-mobile {
  padding: 0.85rem;
  display: grid;
  gap: 0.75rem;
}

.kontak-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 0.9rem;
  background: #fff;
}

.kontak-mobile-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.kontak-mobile-card__meta {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--gw-line);
}

.kontak-menu-btn {
  color: var(--gw-forest) !important;
}

.kontak-menu {
  border-radius: 10px !important;
}

.kontak-dialog-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.kontak-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.95rem 1.1rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.kontak-dialog-header__copy {
  display: flex;
  align-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
}

.kontak-dialog-header__copy .v-icon {
  color: var(--gw-mint) !important;
}

.kontak-dialog-body {
  padding: 1.25rem 1.25rem 0.75rem !important;
}

.kontak-field-label {
  margin-bottom: 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gw-forest);
}

.kontak-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.kontak-field >>> .v-icon {
  color: var(--gw-leaf) !important;
}

.kontak-switch-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 12px;
  border: 1px solid var(--gw-line);
  background: var(--gw-fog);
}

.kontak-switch-box__title {
  font-weight: 600;
  color: var(--gw-ink);
  font-size: 0.92rem;
}

.kontak-switch-box__sub {
  margin-top: 0.2rem;
  font-size: 0.78rem;
  color: var(--gw-muted);
}

.kontak-divider {
  border-color: var(--gw-line) !important;
}

.kontak-dialog-actions {
  padding: 0.9rem 1.1rem !important;
  background: var(--gw-paper);
}

.kontak-btn-ghost {
  color: var(--gw-muted) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

@media (max-width: 600px) {
  .kontak-toolbar__actions {
    width: 100%;
  }

  .kontak-search {
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  .kontak-toolbar__actions .kontak-btn-primary {
    width: 100%;
  }
}
</style>
